import { useQuery } from "@tanstack/react-query";

import { getRiskScope } from "@/api/risk";
import { RiskQueryKeys } from "./riskQueryKeys";

// The viewer's OWN watch scope (league ids + derived country states). Shared
// by the Ülkeler and Ligler tabs; React Query de-duplicates the fetch.
export const useRiskScope = () => {
  return useQuery({
    queryKey: [RiskQueryKeys.Scope],
    queryFn: ({ signal }) => getRiskScope({ signal }),
  });
};
